import axios from 'axios';

const inferApiBase = () => {
  if (typeof window === 'undefined') return '/api';
  const host = window.location.hostname.toLowerCase();
  if (host === 'frolickingelfstudio.ca' || host.endsWith('.frolickingelfstudio.ca')) {
    return 'https://api-necro.frolickingelfstudio.ca/api';
  }
  return '/api';
};

const API_BASE = process.env.REACT_APP_API_BASE || inferApiBase();

const client = axios.create({ baseURL: API_BASE });

// Attach access token to every request
client.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// On 401: attempt token refresh, then retry once
client.interceptors.response.use(
  (res) => res,
  async (err) => {
    const original = err.config;
    if (err.response?.status === 401 && !original._retry) {
      original._retry = true;
      const refreshToken = localStorage.getItem('refreshToken');
      if (refreshToken) {
        try {
          const { data } = await axios.post(`${API_BASE}/auth/refresh`, { refreshToken });
          localStorage.setItem('accessToken', data.accessToken);
          localStorage.setItem('refreshToken', data.refreshToken);
          original.headers.Authorization = `Bearer ${data.accessToken}`;
          return client(original);
        } catch {
          localStorage.clear();
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(err);
  }
);

export default client;
